export function TopicVisual({ idPrefix }: { idPrefix: string }) {
	const facets = [
		{ angle: -90, label: 'Análisis', r: 120 },
		{ angle: -30, label: 'Contexto', r: 120 },
		{ angle: 30, label: 'Criterio', r: 120 },
		{ angle: 90, label: 'Aplicación', r: 120 },
		{ angle: 150, label: 'Notas', r: 120 },
		{ angle: 210, label: 'Recursos', r: 120 },
	]
	const cx = 280
	const cy = 214
	const glowId = `${idPrefix}-topic-glow`
	const gradientId = `${idPrefix}-topic-center`

	return (
		<svg
			viewBox="0 0 560 420"
			className="h-full w-full"
			role="img"
			aria-label="Tema: viabilidad del encargo, 6 facetas"
			style={{ color: 'var(--gold-text)' }}
		>
			<defs>
				<filter id={glowId}>
					<feGaussianBlur
						in="SourceGraphic"
						stdDeviation="6"
						result="blurred"
					/>
					<feMerge>
						<feMergeNode in="blurred" />
						<feMergeNode in="SourceGraphic" />
					</feMerge>
				</filter>
				<radialGradient id={gradientId} cx="50%" cy="50%" r="50%">
					<stop offset="0%" stopColor="currentColor" stopOpacity="0.25" />
					<stop offset="100%" stopColor="currentColor" stopOpacity="0" />
				</radialGradient>
			</defs>

			<text
				x={cx}
				y="30"
				textAnchor="middle"
				fontSize="12"
				fill="rgba(255,255,255,0.42)"
				fontFamily="ui-monospace, SFMono-Regular, monospace"
				letterSpacing="2"
			>
				TEMA · VIABILIDAD DEL ENCARGO
			</text>

			<circle
				cx={cx}
				cy={cy}
				r="136"
				fill="none"
				stroke="currentColor"
				strokeWidth="0.5"
				strokeOpacity="0.08"
			/>
			<circle
				cx={cx}
				cy={cy}
				r="82"
				fill="none"
				stroke="currentColor"
				strokeWidth="0.5"
				strokeOpacity="0.1"
			/>
			<circle cx={cx} cy={cy} r="52" fill={`url(#${gradientId})`} />

			<g transform={`translate(${cx}, ${cy})`}>
				<rect
					x="-20"
					y="-20"
					width="40"
					height="40"
					rx="4"
					transform="rotate(45)"
					fill="currentColor"
					fillOpacity="0.12"
					stroke="currentColor"
					strokeWidth="1.6"
					strokeOpacity="0.7"
					filter={`url(#${glowId})`}
				/>
				<rect
					x="-9"
					y="-9"
					width="18"
					height="18"
					rx="2"
					transform="rotate(45)"
					fill="currentColor"
					fillOpacity="0.18"
					stroke="currentColor"
					strokeWidth="1"
					strokeOpacity="0.4"
				/>
				<circle r="4" fill="currentColor" fillOpacity="0.75">
					<animate
						attributeName="r"
						values="4;5.5;4"
						dur="2s"
						repeatCount="indefinite"
					/>
				</circle>
			</g>

			{facets.map((facet, index) => {
				const rad = (facet.angle * Math.PI) / 180
				const ex = cx + Math.cos(rad) * facet.r
				const ey = cy + Math.sin(rad) * facet.r
				const midX = cx + Math.cos(rad) * 36
				const midY = cy + Math.sin(rad) * 36
				const labelX = cx + Math.cos(rad) * (facet.r + 28)
				const labelY = cy + Math.sin(rad) * (facet.r + 28) + 4

				return (
					<g key={facet.label}>
						<line
							x1={midX}
							y1={midY}
							x2={ex}
							y2={ey}
							stroke="currentColor"
							strokeWidth="1"
							strokeOpacity="0.22"
							strokeLinecap="round"
						/>
						<circle r="1.6" fill="currentColor" fillOpacity="0.7">
							<animateMotion
								dur={`${2.6 + index * 0.3}s`}
								repeatCount="indefinite"
								path={`M ${midX - cx},${midY - cy} L ${ex - cx},${ey - cy}`}
								begin={`${index * 0.4}s`}
							/>
							<set attributeName="cx" to={String(cx)} />
							<set attributeName="cy" to={String(cy)} />
						</circle>
						<circle
							cx={ex}
							cy={ey}
							r="8"
							fill="currentColor"
							fillOpacity="0.08"
							stroke="currentColor"
							strokeWidth="1"
							strokeOpacity="0.32"
						/>
						<circle
							cx={ex}
							cy={ey}
							r="3"
							fill="currentColor"
							fillOpacity="0.4"
						/>
						<text
							x={labelX}
							y={labelY}
							textAnchor="middle"
							fontSize="12"
							fill="rgba(255,255,255,0.7)"
						>
							{facet.label}
						</text>
					</g>
				)
			})}

			<text
				x={cx}
				y="398"
				textAnchor="middle"
				fontSize="12"
				fill="rgba(255,255,255,0.38)"
			>
				6 facetas · múltiples ángulos sobre un mismo concepto
			</text>
		</svg>
	)
}
